import AbstractCustomerValueModel from '../abstract_customer_value_model';
import BenefitsChart from '../../charts/benefits_chart';
import BenefitsChartValue from '../../charts/benefits_chart_value';
import BenefitsWaterfallChart from '../../charts/benefits_waterfall_chart';

class AgilityPreparis extends AbstractCustomerValueModel {
  custom_chart_classes() {
    return { BenefitsChart, BenefitsChartValue, BenefitsWaterfallChart };
  }

  pct_rdxn_capital_spend() {
    return this.input.pct_rdxn_capital_spend / 100;
  }

  pct_rdxn_rental_spend() {
    return this.input.pct_rdxn_rental_spend / 100;
  }

  pct_rdxn_generator_maintenance() {
    return this.input.pct_rdxn_generator_maintenance / 100;
  }

  pct_rdxn_response_time() {
    return this.input.pct_rdxn_response_time / 100;
  }

  pct_rdxn_outage_duration_loss_attr() {
    return this.input.pct_rdxn_outage_duration_loss_attr / 100;
  }

  pct_rdxn_outage_duration_spoilage_attr() {
    return this.input.pct_rdxn_outage_duration_spoilage_attr / 100;
  }

  pct_rdxn_outage_duration_idle_attr() {
    return this.input.pct_rdxn_outage_duration_idle_attr / 100;
  }

  pct_rdxn_premiums() {
    return this.input.pct_rdxn_premiums / 100;
  }

  pct_rdxn_rep_dmg_power() {
    return this.input.pct_rdxn_rep_dmg_power / 100;
  }

  pct_rdxn_rep_dmg_flex() {
    return this.input.pct_rdxn_rep_dmg_flex / 100;
  }

  adoption_rate(year) {
    return 1.0;
  }

  annual_mgr_salary() {
    return this.input.annual_mgr_salary;
  }

  annual_price_increase(year) {
    return (1 + (this.input.annual_increase / 100)) ** (year - 1);
  }

  annual_prod_team_salary() {
    return this.input.annual_prod_team_salary;
  }

  annual_revenue() {
    return this.input.annual_revenue;
  }

  // Configurator - Q99
  avg_price_of_new_generator() {
    let size = 0;

    if (this.product_flex() === 1 && this.product_power() === 0) {
      size = this.generator_size_readyflex();
    } else if (this.product_flex() === 0 && this.product_power() === 1) {
      size = this.largest_generator_size();
    } else {
      size = Math.max(this.generator_size_readyflex(), this.largest_generator_size());
    }

    if (size === 56) {
      return 33750;
    } else if (size === 100) {
      return 38000;
    } else if (size === 150) {
      return 45000;
    } else if (size === 200) {
      return 68000;
    } else if (size === 250) {
      return 74000;
    } else if (size === 300) {
      return 84000;
    } else if (size === 350) {
      return 90000;
    } else if (size === 500) {
      return 114000;
    } else if (size === 750) {
      return 175000;
    } else if (size === 1000) {
      return 250000;
    } else if (size === 1500) {
      return 425000;
    }

    return 555000;
  }

  burden_rate() {
    return this.input.burden_rate;
  }

  declare_fee() {
    if (this.input.declare_fee_edited === 'true') {
      return this.input.declare_fee;
    }
    if (this.product_power() === 0) { return 0; }

    return 10000;
  }

  declares() {
    return this.input.declares;
  }

  fte_per_shift() {
    return this.input.fte_per_shift;
  }

  fully_burdened_salary(salary) {
    return salary * this.burden_rate();
  }

  generator_size_readyflex() {
    return this.input.generator_size_readyflex;
  }

  mrr_readypower(size) {
    if (size === 56) {
      if (this.smb_or_enterprise() === 'SMB') {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 366;
          } else {
            return 250;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 475.80;
          } else {
            return 325;
          } 
        }
      } else {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 439.20;
          } else {
            return 300;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 570.96;
          } else {
            return 390;
          } 
        }
      }
    } else if (size === 100) {
      if (this.smb_or_enterprise() === 'SMB') {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 438;
          } else {
            return 300;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 569.40;
          } else {
            return 390;
          } 
        }
      } else {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 525.60;
          } else {
            return 360;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 683.28;
          } else {
            return 468;
          } 
        }
      }
    } else if (size === 150) {
      if (this.smb_or_enterprise() === 'SMB') {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 504;
          } else {
            return 350;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 655.20;
          } else {
            return 455;
          } 
        }
      } else {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 604.80;
          } else {
            return 420;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 786.24;
          } else {
            return 546;
          } 
        }
      }
    } else if (size === 200) {
      if (this.smb_or_enterprise() === 'SMB') {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 572;
          } else {
            return 400;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 743.6;
          } else {
            return 520;
          } 
        }
      } else {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 686.40;
          } else {
            return 480;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 892.32;
          } else {
            return 624;
          } 
        }
      }
    } else if (size === 250) {
      if (this.smb_or_enterprise() === 'SMB') {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 651;
          } else {
            return 450;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 846.30;
          } else {
            return 585;
          } 
        }
      } else {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 781.20;
          } else {
            return 540;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 1015.56;
          } else {
            return 702;
          } 
        }
      }
    } else if (size === 300) {
      if (this.smb_or_enterprise() === 'SMB') {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 715;
          } else {
            return 500;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 929.50;
          } else {
            return 650;
          } 
        }
      } else {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 858;
          } else {
            return 600;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 1115.4;
          } else {
            return 780;
          } 
        }
      }
    } else if (size === 350) {
      if (this.smb_or_enterprise() === 'SMB') {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 824;
          } else {
            return 550;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 1071.2;
          } else {
            return 715;
          } 
        }
      } else {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 988.8;
          } else {
            return 660;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 1285.44;
          } else {
            return 858;
          } 
        }
      }
    } else if (size === 500) {
      if (this.smb_or_enterprise() === 'SMB') {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 1084;
          } else {
            return 750;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 1409.20;
          } else {
            return 975;
          } 
        }
      } else {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 1300.8;
          } else {
            return 900;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 1691.04;
          } else {
            return 1170;
          } 
        }
      }
    } else if (size === 750) {
      if (this.smb_or_enterprise() === 'SMB') {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 1677;
          } else {
            return 1200;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 2180.1;
          } else {
            return 1560;
          } 
        }
      } else {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 2012.4;
          } else {
            return 1440;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 2616.12;
          } else {
            return 1872;
          } 
        }
      }
    } else if (size === 1000) {
      if (this.smb_or_enterprise() === 'SMB') {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 2020;
          } else {
            return 1500;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 2626;
          } else {
            return 1950;
          } 
        }
      } else {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 2424.00;
          } else {
            return 1800;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 3151.2;
          } else {
            return 2340.00;
          } 
        }
      }
    } else if (size === 1500) {
      if (this.smb_or_enterprise() === 'SMB') {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 3125;
          } else {
            return 2400;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 4062.5;
          } else {
            return 3120;
          } 
        }
      } else {
        if (this.low_or_high_risk() === 'Low') {
          if (this.include_enhanced_coverage_pricing()) {
            return 3750;
          } else {
            return 2880;
          }
        } else {
          if (this.include_enhanced_coverage_pricing()) {
            return 4875;
          } else {
            return 3744;
          } 
        }
      }
    }

    if (this.smb_or_enterprise() === 'SMB') {
      if (this.low_or_high_risk() === 'Low') {
        if (this.include_enhanced_coverage_pricing()) {
          return 4327;
        } else {
          return 3400;
        }
      } else {
        if (this.include_enhanced_coverage_pricing()) {
          return 5625.1;
        } else {
          return 4420;
        } 
      }
    } else {
      if (this.low_or_high_risk() === 'Low') {
        if (this.include_enhanced_coverage_pricing()) {
          return 5192.4;
        } else {
          return 4080;
        }
      } else {
        if (this.include_enhanced_coverage_pricing()) {
          return 6750.12;
        } else {
          return 5304;
        } 
      }
    }
  }

  g1_mrr_readyflex() {
    const size = this.generator_size_readyflex();

    if (size === 56) {
      return 2772;
    } else if (size === 100) {
      return 3450;
    } else if (size === 150) {
      return 4530;
    } else if (size === 200) {
      return 4958;
    } else if (size === 250) {
      return 6465;
    } else if (size === 300) {
      return 6465;
    } else if (size === 350) {
      return 8000;
    } else if (size === 500) {
      return 11565;
    } else if (size === 750) {
      return 13572;
    } else if (size === 1000) {
      return 24586;
    } else if (size === 1500) {
      return 26964;
    }

    return 27900;
  }

  generator_maintenance_cost() {
    if (this.input.generator_maintenance_cost_edited === 'true') {
      return this.input.generator_maintenance_cost;
    }

    return 0.1 * this.avg_price_of_new_generator();
  }

  generator_purchase_cost() {
    if (this.input.generator_purchase_cost_edited === 'true') {
      return this.input.generator_purchase_cost;
    }

    return this.g1_purchase_cost()
      + this.g2_purchase_cost()
      + this.g3_purchase_cost();
  }
  
  g1_purchase_cost() {
    return this.purchase_cost_for_size(this.largest_generator_size());
  }
  
  g2_purchase_cost() {
    if (this.declares() === 1) { return 0;}
  
    return this.purchase_cost_for_size(this.second_largest_generator_size());
  }
  
  g3_purchase_cost() {
    if (this.declares() !== 3) { return 0;}
  
    return this.purchase_cost_for_size(this.third_largest_generator_size());
  }

  g1_rental_cost() {
    return this.rental_cost_for_size(this.largest_generator_size());
  }

  g2_rental_cost() {
    if (this.declares() === 1) { return 0;}

    return this.rental_cost_for_size(this.second_largest_generator_size());
  }

  g3_rental_cost() {
    if (this.declares() !== 3) { return 0;}

    return this.rental_cost_for_size(this.third_largest_generator_size());
  }

  rental_cost_for_size(size) {
    if (size === 56) {
      return 1867;
    } else if (size === 100) {
      return 2367;
    } else if (size === 150) {
      return 3106;
    } else if (size === 200) {
      return 3403;
    } else if (size === 250) {
      return 3994;
    } else if (size === 300) {
      return 4438;
    } else if (size === 350) {
      return 6286;
    } else if (size === 500) {
      return 7934;
    } else if (size === 750) {
      return 12204;
    } else if (size === 1000) {
      return 16871;
    } else if (size === 1500) {
      return 24408;
    }

    return 31212;
  }

  generator_rental_cost() {
    if (this.input.generator_rental_cost_edited === 'true') {
      return this.input.generator_rental_cost;
    }

    return this.g1_rental_cost()
      + this.g2_rental_cost()
      + this.g3_rental_cost();
  }

  hr_outage_shortened_by() {
    return this.input.hr_outage_shortened_by;
  }

  hr_per_outage() {
    return this.input.hr_per_outage;
  }

  hr_per_yr() {
    return 1880;
  }
  
  include_enhanced_coverage_pricing() {
    return (this.input.include_enhanced_coverage_pricing === 'Yes');
  }

  insurance_cost() {
    if (this.input.insurance_cost_edited === 'true') {
      return this.input.insurance_cost;
    }

    return 0.005 * this.annual_revenue();
  }

  largest_generator_size() {
    return this.input.largest_generator_size;
  }

  loss_per_hr_disruption() {
    if (this.input.loss_per_hr_disruption_edited === 'true') {
      return this.input.loss_per_hr_disruption;
    }

    return this.annual_revenue()
      / (this.weeks_per_yr() * this.manufacturing_hr_per_day() * this.manufacturing_days_per_week());
  }
  
  low_or_high_risk() {
    return this.input.low_or_high_risk;
  }

  manufacturing_days_per_week() {
    return 7;
  }

  manufacturing_hr_per_day() {
    return 24;
  }

  months_rental_used() {
    return this.input.months_rental_used;
  }

  number_of_locations() {
    return this.input.number_of_locations;
  }

  outages_per_yr() {
    return 1;
  }

  // As of v0.8, this always returns 0 because ReadyFlex has been removed from the model.
  product_flex() {
    return 0;
  }

  // As of v0.8, this always returns 1 because ReadyPower is the only product in the model
  product_power() {
    return 1;
  }
  
  purchase_cost_for_size(size) {
    if (size === 56) {
      return 33750;
    } else if (size === 100) {
      return 38000;
    } else if (size === 150) {
      return 45000;
    } else if (size === 200) {
      return 68000;
    } else if (size === 250) {
      return 74000;
    } else if (size === 300) {
      return 84000;
    } else if (size === 350) {
      return 90000;
    } else if (size === 500) {
      return 114000;
    } else if (size === 750) {
      return 175000;
    } else if (size === 1000) {
      return 250000;
    } else if (size === 1500) {
      return 425000;
    }
  
    return 555000;
  }

  readypower_fee_g1() {
    if (this.product_power() === 0) { return 0; }

    if (this.input.readypower_fee_g1_edited === 'true') {
      return this.input.readypower_fee_g1;
    }

    return this.virtual_coverage_months() * this.mrr_readypower(this.largest_generator_size());
  }

  readypower_fee_g2() {
    if (this.product_power() === 0) { return 0; }
    if (this.declares() === 1) { return 0; }

    if (this.input.readypower_fee_g2_edited === 'true') {
      return this.input.readypower_fee_g2;
    }

    return this.virtual_coverage_months() * this.mrr_readypower(this.second_largest_generator_size());
  }

  readypower_fee_g3() {
    if (this.product_power() === 0) { return 0; }
    if (this.declares() !== 3) { return 0; }

    if (this.input.readypower_fee_g3_edited === 'true') {
      return this.input.readypower_fee_g3;
    }

    return this.virtual_coverage_months() * this.mrr_readypower(this.third_largest_generator_size());
  }
  
  rent_or_buy() {
    return this.input.rent_or_buy;
  }

  second_largest_generator_size() {
    return this.input.second_largest_generator_size;
  }

  session_type() {
    return this.input.session_type;
  }
  
  smb_or_enterprise() {
    return this.input.smb_or_enterprise;
  }

  third_largest_generator_size() {
    return this.input.third_largest_generator_size;
  }

  value_of_inventory() {
    if (this.input.value_of_inventory_edited === 'true') {
      return this.input.value_of_inventory;
    }

    return 0.17 * (this.annual_revenue() / (this.weeks_per_yr() * this.manufacturing_days_per_week() * this.manufacturing_hr_per_day()));
  }

  virtual_coverage_months() {
    return this.input.virtual_coverage_months;
  }

  weeks_per_yr() {
    return 50;
  }

  // Benefit 1a
  reduce_capital_spend(year = 1) {
    if (year > 1) { return 0; }
    if (this.rent_or_buy() === 'Rent') { return 0; }

    return this.generator_purchase_cost() * this.number_of_locations()
      * this.pct_rdxn_capital_spend();
  }

  // Benefit 1b
  reduce_rental_spend(year = 2) {
    if (this.rent_or_buy() === 'Buy') { return 0; }
    
    return this.generator_rental_cost() * this.months_rental_used()
      * this.pct_rdxn_rental_spend();
  }

  // Benefit 2
  eliminate_generator_maintenance() {
    if (this.rent_or_buy() === 'Rent') { return 0; }
    
    return this.generator_maintenance_cost() * this.number_of_locations()
      * this.pct_rdxn_generator_maintenance();
  }

  // Benefit 3
  reduce_outage_response_time(year = 2) {
    if (year !== 2) { return 0; }
    if (this.include_enhanced_coverage_pricing() === false) { return 0; }

    return this.hr_per_outage() * this.outages_per_yr()
      * (this.fully_burdened_salary(this.annual_mgr_salary()) / this.hr_per_yr())
      * this.pct_rdxn_response_time();
  }

  // Benefit 4
  reduce_outage_duration_loss(year = 2) {
    if (year !== 2) { return 0; }
    if (this.include_enhanced_coverage_pricing() === false) { return 0; }

    let benefit = 0;

    if (this.product_power() === 1) {
      benefit += this.loss_per_hr_disruption() * this.hr_outage_shortened_by()
        * this.outages_per_yr() * (this.virtual_coverage_months() / 12)
        * this.pct_rdxn_outage_duration_loss_attr();
    }

    return benefit;
  }

  // Benefit 5
  reduce_outage_duration_spoilage(year = 2) {
    if (year !== 2) { return 0; }
    if (this.include_enhanced_coverage_pricing() === false) { return 0; }

    let benefit = 0;

    if (this.product_power() === 1) {
      benefit += this.value_of_inventory() * this.hr_outage_shortened_by()
        * this.outages_per_yr() * (this.virtual_coverage_months() / 12)
        * this.pct_rdxn_outage_duration_spoilage_attr();
    }

    return benefit;
  }

  // Benefit 6
  reduce_outage_duration_idle(year = 2) {
    if (year !== 2) { return 0; }
    if (this.include_enhanced_coverage_pricing() === false) { return 0; }

    let benefit = 0;

    if (this.product_power() === 1) {
      benefit += this.fte_per_shift()
        * this.hr_outage_shortened_by()
        * this.outages_per_yr()
        * (this.fully_burdened_salary(this.annual_prod_team_salary()) / this.hr_per_yr())
        * (this.virtual_coverage_months() / 12)
        * this.pct_rdxn_outage_duration_idle_attr();
    }

    return benefit;
  }

  // Benefit 7
  reduce_premiums(year = 1) {
    return this.insurance_cost() * this.pct_rdxn_premiums();
  }

  // Benefit 8
  reduce_rep_dmg(year = 2) {
    if (year !== 2) { return 0; }
    if (this.include_enhanced_coverage_pricing() === false) { return 0; }

    let benefit = 0;

    if (this.product_power() === 1) {
      benefit += this.annual_revenue() * (this.virtual_coverage_months() / 12)
        * this.pct_rdxn_rep_dmg_power();
    }

    return benefit;
  }

  all_benefits() {
    return [
      'reduce_capital_spend',
      'reduce_rental_spend',
      'eliminate_generator_maintenance',
      'reduce_outage_response_time',
      'reduce_outage_duration_loss',
      'reduce_outage_duration_spoilage',
      'reduce_outage_duration_idle',
      'reduce_premiums',
      'reduce_rep_dmg'
    ];
  }

  value_drivers() {
    return [
      'control_costs',
      'mitigate_risk'
    ];
  }

  control_costs(year = 1) {
    return this.reduce_capital_spend(year)
      + this.reduce_rental_spend(year)
      + this.eliminate_generator_maintenance(year)
      + this.reduce_outage_response_time(year);
  }

  mitigate_risk(year = 1) {
    return this.reduce_outage_duration_loss(year)
      + this.reduce_outage_duration_spoilage(year)
      + this.reduce_outage_duration_idle(year)
      + this.reduce_premiums(year)
      + this.reduce_rep_dmg(year);
  }

  total_annual_investment(year = 1) {
    const base = this.readypower_fee_g1()
          + this.readypower_fee_g2()
          + this.readypower_fee_g3();

    if (year === 1) {
      return base;
    }

    return base * this.annual_price_increase(year);
  }

  control_costs_label() {
    return this.input.control_costs_label;
  }

  mitigate_risk_label() {
    return this.input.mitigate_risk_label;
  }

  reduce_capital_spend_label() {
    return this.input.reduce_capital_spend_label;
  }

  reduce_rental_spend_label() {
    return this.input.reduce_rental_spend_label;
  }

  eliminate_generator_maintenance_label() {
    return this.input.eliminate_generator_maintenance_label;
  }

  reduce_outage_response_time_label() {
    return this.input.reduce_outage_response_time_label;
  }

  reduce_outage_duration_loss_label() {
    return this.input.reduce_outage_duration_loss_label;
  }

  reduce_outage_duration_spoilage_label() {
    return this.input.reduce_outage_duration_spoilage_label;
  }

  reduce_outage_duration_idle_label() {
    return this.input.reduce_outage_duration_idle_label;
  }

  reduce_premiums_label() {
    return this.input.reduce_premiums_label;
  }

  reduce_rep_dmg_label() {
    return this.input.reduce_rep_dmg_label;
  }
  
  roi(end_year_param) {
    const end_year = this.ending_year(end_year_param);
    return this.total_cumulative_value_for_all_benefits(end_year)
           / this.cumulative_investment(end_year);
  }
}

export default AgilityPreparis;
